import styles from './About.module.css';
// import photo2 from '../image/2.JPG';
import { useEffect, useRef } from 'react';
import SliderImage from './SliderImage';
import {cardsData} from './SliderData';

export default function About({profile}) {
const hiddenElements = useRef([]); // array per gli elementi da osservare

    useEffect(() => {
    const currentElements = hiddenElements.current;
    // Creiamo l'osservatore
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add(styles.show);  // Usa styles.show per evitare conflitti
            } else {
                entry.target.classList.remove(styles.show);
            }
        });
    });

    // Osserviamo ogni elemento nascosto
    currentElements.forEach((el) => observer.observe(el));

    // Pulizia dell'observer quando il componente si smonta
    return () => {
        currentElements.forEach((el) => observer.unobserve(el));
    };
    }, []);
    

    return (
        <section className={styles.about}>
            <div className={styles.aboutText}>
                <h2>CHI SONO</h2>
                <p>{profile.descr1}
                </p>
            </div>
            <h3>Informazioni personali</h3>
            <div className={styles.aboutInfo}>
                <SliderImage cardsData={cardsData} />
                <div className={`${styles.hidden} ${styles.aboutInfoDetails}`} data-nosnippet ref={(el) => (hiddenElements.current[1] = el)}>
                    <div className={styles.listDetail}>
                        <ul>
                            {/* <li><i className='bx bx-chevron-right'></i><b>Compleanno:</b> {profile.hb}</li> */}
                            <li><i className='bx bx-chevron-right'></i><b>Età:</b> {profile.age}</li>
                            <li><i className='bx bx-chevron-right'></i><b>E-Mail:</b> {profile.mail}</li>
                            <li><i className='bx bx-chevron-right'></i><b>Città:</b> {profile.city}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}